const SvgComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      role="image"
      aria-label="exists"
    >
      <path
        d="M18.0938 1.53125L7.15625 12.4688L1.6875 7"
        stroke="#910A2D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgComponent
